import { getButtonAttribution } from 'site/Renderer/utils/getButtonAttribution'

import {
  ActionButton,
  CardButtonAttribution,
  LinkButtonProps,
  LinkButtonPropsByObject,
  ModalButtonProps,
  PublicButtonPropsByObject,
  PublicButtonPropsWithType
} from '../CardCarousel.types'

export function isLinkButtonPropsByObject(
  button: ActionButton,
  itemUuid: string
): button is LinkButtonPropsByObject {
  const entry = (button as LinkButtonPropsByObject)?.[itemUuid]
  return entry !== undefined && (entry as LinkButtonProps)?.type === 'link'
}

export function isPublicButtonPropsByObject(
  button: ActionButton,
  itemUuid: string
): button is PublicButtonPropsByObject {
  const entry = (button as PublicButtonPropsByObject)?.[itemUuid]
  return (
    entry !== undefined &&
    (entry as PublicButtonPropsWithType)?.type === 'public'
  )
}

export function isModalButtonProps(
  button: ActionButton
): button is ModalButtonProps {
  return (button as ModalButtonProps)?.type === 'modal'
}

const NULL_ATTRIBUTION: CardButtonAttribution = { type: null }

export function getCardButtonAttribution(
  button: ActionButton,
  itemUuid: string
): CardButtonAttribution {
  return getButtonAttribution<CardButtonAttribution>(button, itemUuid, {
    singleMatchers: [
      {
        match: (b) => isModalButtonProps(b as ActionButton),
        attribution: (b) => ({ type: 'modal', props: b as ModalButtonProps })
      }
    ],
    getPerItemAttribution: (b, id) => {
      if (isLinkButtonPropsByObject(b as ActionButton, id)) {
        return { type: 'link', props: (b as LinkButtonPropsByObject)[id] }
      }
      if (isPublicButtonPropsByObject(b as ActionButton, id)) {
        return { type: 'public', props: (b as PublicButtonPropsByObject)[id] }
      }
      return null
    },
    nullAttribution: NULL_ATTRIBUTION
  })
}
